import { ServicesContainer } from '@/services';
import { LogoutCompleteEvent } from '@/services/analytics/events';
import { AnalyticsEventType } from '@/services/analytics/platforms/adobe-analytics/models';
import { AppState } from '@/store';
import { Store } from 'vuex';
import { AdobeBaseEvent } from './adobe-base-event';

export class AdobeLogoutCompleteEvent extends AdobeBaseEvent {
  event = AnalyticsEventType.LogoutComplete;

  constructor(event: LogoutCompleteEvent, store: Store<AppState>, services: ServicesContainer) {
    super(store, services);
    this.account.userID = store.state.customer.profile?.customerIdHash;
  }
}